import { css } from '@emotion/core';

export const purgeButtonContainer = css`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  button {
    height: 28px;
    line-height: 28px;
  }
`;
